import loadingImg from "@/assets/images/app/icon-olivia.png";
import { twMerge } from "tailwind-merge";

interface LoadingPropsType {
  className?: string;
  showText?: boolean;
}
export default function Loading({
  className,
  showText = true,
}: LoadingPropsType) {
  return (
    <div className="flex items-center gap-2">
      <img src={loadingImg} alt="loading" className="h-4 w-4 rotate" />
      {showText && (
        <span className={twMerge(className)}>Loading</span>
      )}
    </div>
  );
}
